/** Recursively sort object keys for stable agent-payload JSON display. */
export function sortJsonDeep(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(sortJsonDeep);
  }
  if (value !== null && typeof value === "object") {
    const record = value as Record<string, unknown>;
    const sorted = Object.keys(record).sort((a, b) => a.localeCompare(b));
    return Object.fromEntries(sorted.map((key) => [key, sortJsonDeep(record[key])]));
  }
  return value;
}

export function formatSortedAgentPayloadJson(value: unknown): string {
  return JSON.stringify(sortJsonDeep(value), null, 2);
}
